/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/chicken-game/config/constants";

// const chickenGameAtlas0 = require("Images/games/chicken-game/atlas_chicken-game-0.png");
// const chickenGameAtlas1 = require("Images/games/chicken-game/atlas_chicken-game-1.png");
const atlasReq = require.context("Images/games/chicken-game", false, /atlas_.*\.png$/);
const chickenGameAtlasJson = require("Data/games/atlas_chicken-game.json");

export default class Loader extends Phaser.Scene
{
  constructor()
  {
    super({
      key: "Loader"
    });
  }

  init()
  {
    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.add.text(gameWidth / 2, gameHeight / 2, "Loading...", { fontFamily: "RabbitOnTheMoon", fontSize: 18, fontWeight: "normal", fill: "#000000" }).setOrigin(0.5);
  }

  preload()
  {
    // https://labs.phaser.io/index.html?dir=loader/texture%20atlas%20multi/&q=
    // this.load.atlas(CONSTANTS.ATLAS_KEY, [ chickenGameAtlas0, chickenGameAtlas1 ], chickenGameAtlasJson);
    
    this.processAtlasJson();
    // https://photonstorm.github.io/phaser3-docs/Phaser.Loader.LoaderPlugin.html#multiatlas
    this.load.multiatlas(CONSTANTS.ATLAS_KEY, chickenGameAtlasJson);
    this.loadFonts();
  }

  processAtlasJson()
  {
    // Phaser's multiatlas looks at the images inside the atlas json file. Since we're using webpack we don't know what
    // the url will be for our atlas .png files ... With this we require them (getting the actual url) and overwrite
    // them in the json data (not the file itself) before giving it to Phaser
    for(var i = 0; i < chickenGameAtlasJson.textures.length; i++)
    {
      var image = chickenGameAtlasJson.textures[i].image;

      var atlasRequire = "./" + image;

      if(atlasReq.keys().includes(atlasRequire))
      {
        chickenGameAtlasJson.textures[i].image = atlasReq(atlasRequire);
      }
      else
      {
        console.warning("Atlas '" + image + "' not found");
      }
    }
  }

  create()
  {
    this.createAnimations();
    this.scene.start("Menu");
  }

  loadFonts()
  {
    this.preloadFont("RabbitOnTheMoon");
    this.preloadFont("AbadiMTPro-CondExtraBold");
  }

  preloadFont(font)
  {
    var text = this.add.text(0, 0, "text", { fontFamily: font, fontSize: 1, fill: "#FFFFFF" });
    text.visible = false;
  }

  createAnimations()
  {
    // Chick run animations
    for(var i = 0; i < CONSTANTS.CHICK_RUN_DIRECTIONS.length; i++)
    {
      this.createChickRunAnimation(CONSTANTS.CHICK_RUN_DIRECTIONS[i]);
    }

    // Chicken plop animations
    for(var i = 0; i < CONSTANTS.CHICK_HATCH_POSITIONS.length; i++)
    {
      this.createChickenPlopAnimation(CONSTANTS.CHICK_HATCH_POSITIONS[i]);
    }

    // Corinne idle animation
    var runFrameNames = this.anims.generateFrameNames(CONSTANTS.ATLAS_KEY, {
      start: 0, end: 299, zeroPad: 4,
      prefix: "animations/corinne/", suffix: ".png"
    });
    this.anims.create({ key: "corinne-idle", frames: runFrameNames, frameRate: 10, repeat: -1 });
  }

  createChickRunAnimation(direction)
  {
    var runFrameNames = this.anims.generateFrameNames(CONSTANTS.ATLAS_KEY, {
      start: 1, end: 6, zeroPad: 4,
      prefix: "animations/chicks/run/" + direction + "/", suffix: ".png"
    });
    var animationKey = "chick-run-" + direction;
    this.anims.create({ key: animationKey, frames: runFrameNames, frameRate: 10, repeat: -1 });
  }

  createChickenPlopAnimation(position)
  {
    var runFrameNames = this.anims.generateFrameNames(CONSTANTS.ATLAS_KEY, {
      start: 1, end: 6, zeroPad: 4,
      prefix: "animations/chicks/plop/" + position + "/", suffix: ".png"
    });
    var animationKey = "chick-plop-" + position;
    this.anims.create({ key: animationKey, frames: runFrameNames, frameRate: 10});
  }
}



// WEBPACK FOOTER //
// ./app/js/games/chicken-game/scenes/loader.js